import { SectionNameTypes } from '@assets/model/ScoreUtils';
import * as svgs from './*.svg';
interface SectionIconProps {
    section: SectionNameTypes;
    className?: string;
}

export const GetSectionIconUrl = (section: SectionNameTypes): string => {
    if (!svgs[section]) {
        return null;
    }
    return svgs[section];
};

export const SectionIcon = (p: SectionIconProps) => {
    return (
        <div className={p.className}>
            <img src={svgs[p.section]} />
        </div>
    );
};
